// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"1df9efc9","96":"196df1d4","233":"41287e59","453":"ce451b92","469":"42221a59","979":"b458a81e","997":"292521af"}[chunkId] + ".chunk.js";
};